<template>
  <div
    class="date-row date-check-time">
    <div>
      <div class="date-row__label">
        {{ label }}
        <sPopover
          :border="false"
          class="ml-2"
          :content="$t('Automation.DateHint')"
          trigger="hover"
          type="white"
          width="228">
          <sIcon
            slot="reference"
            type="info"/>
        </sPopover>
      </div>
      <sInputNumber
        clearable
        :disabled="disabled"
        placeholder="0"
        :precision="0"
        :value="valueMutable.date"
        @update:value="val => sendValues('date', val)"/>
    </div>
    <div
      v-if="useTime"
      class="my-auto ml-3">
      <div class="date-row__label"/>
      <sCheckbox
        :disabled="disabled"
        :value="valueMutable.check"
        @input="val => sendValues('check', val)">
        {{ $t('Tenders.ChangeTime') }}
      </sCheckbox>
    </div>
    <div>
      <div class="date-row__label">
        <template v-if="valueMutable.check">
          {{ $t('Tenders.Time') }}
        </template>
      </div>
      <TimeMenu
        v-if="valueMutable.check"
        class_name="ml-0"
        :day="false"
        :disabled="disabled"
        max="18:00:00"
        min="09:00:00"
        :second="false"
        :time="valueMutable.time"
        @update:time="val => sendValues('time', val)"/>
    </div>
  </div>
</template>
<script>
import TimeMenu from 'components/common/inputs/TimeMenu.vue'

export default {
  name: 'automationActionDateCheckTime',
  methods: {
    sendValues(key, props) {
      const result = this.$_.cloneDeep(this.valueMutable)
      result[key] = props

      const resultObject = {
        UpdateDateType: this.value?.UpdateDateType,
        NeedOverrideTime: result.check,
        UpdateValue: `${result.date || '0'}.${result.check ? (result.time || '00:00:00') : '00:00:00'}`
      }

      this.$emit('update:value', JSON.stringify(resultObject))
    }
  },
  computed: {
    valueMutable() {
      const defaultValue = {
        date: null,
        check: false,
        time: null,
      }
      if (!this.value?.UpdateValue?.trim()) {
        return defaultValue
      }
      const result = this.value?.UpdateValue.split('.')
      if (!result || result.length !== 2) {
        return defaultValue
      }
      return {
        date: result[0],
        check: this.value?.NeedOverrideTime,
        time: result[1],
      }
    }
  },
  components: {
    TimeMenu,
  },
  props: {
    value: {
      type: Object
    },
    label: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    useTime: {
      type: Boolean,
      default: true
    }
  },
}
</script>
<style scoped lang="scss">
.date-row {
  margin-top: 10px;
  display: grid;
  &__label {
    min-height: 16px;
    margin-bottom: 4px;
    display: flex;
    font-size: 0.75rem;
  }
}
.date-check-time {
  grid-template-columns: 180px 180px 180px;
}
</style>
